import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
 import { compose } from 'redux'
import { withStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'
import Button from '../../../common/Button'
import SingleSelect from '../../../common/SingleSelect'
import { notifyError, notifySuccess } from '../../../../Utils/CustomNotifcations'
import { apiFetch } from '../../../../Utils/apiFetch'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  }
})

class ChangesOwnerShipe extends Component {
  constructor () {
    super()
    this.state = {
      isVisableAddBtn: false,
      resultMessage: '',
      defaultOptions: [],
      value: []
    }
    this.formSubmit = this.formSubmit.bind(this)
    this.checkRequiredFields = this.checkRequiredFields.bind(this)
  }
  componentWillMount () {
    apiFetch(`/api/users/list?userId=${this.props.logInUser.id}&limit=100`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => {
        response.json().then(res => {
          if(res.status ==='success'){
            let data = res.data
            let result = data.data.map(item => ({
              ...item,
              label: item.label || item.name,
              value: item.id
            }))
            if (result.length === 0) {
              this.setState({
                resultMessage: 'No option found',
                defaultOptions: ''
              })
            } else {
              this.setState({
                resultMessage: '',
                defaultOptions: result
              })
            }
          }
          else if(res?.statusCode === '440'){
            window.location.replace('/login')
          }
          else if(res.statusCode){
            var err = res?.message.split(':')
            err[1] =err[1].replace(')', "")
            this.props.dispatch(
              notifyError(this.props.translate(err[1]))
            )
          }
          else {
            throw response
          }
        })
     
    }).catch(e => {
      console.log('e =', e)
      //   this.props.dispatch(notifyError({
      //   message: 'somethingWentWrong',
      //   autoDismiss: 5
      // }))
    })
  }

  formSubmit () {
    let { selectedDevice,devices } = this.props
    let { value } = this.state
    const latestDevice = devices?.data?.find(dev => dev.id === selectedDevice.id);
    let obj = {
      newParentId: value.value,
      deviceId: selectedDevice.id,
      oldParentId: latestDevice.parentId
    }
    console.error("selectItemParentId",this.props.devices)
    let apiCall = '/api/devices/migrate/'
    apiFetch(`${apiCall}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...obj
      })
    })
      .then(response => {
          response.json().then(data => {
            if (data.status === 'success') {
              this.props.dispatch(
                notifySuccess(this.props.translate('unitOwnerShipUpdated'))
              )
              if(this.props.getMoreDevices){
                this.props.getMoreDevices()
              }
            } 
            else if(data?.statusCode === '440'){
              window.location.replace('/login')
            }
            else if(data?.statusCode){
              var err = data?.message.split(':')
              err[1] =err[1].replace(')', "")
              this.props.dispatch(
                notifyError(this.props.translate(err[1]))
              )
            }
            else {
              throw response
            }
          })
          this.setState({
            isVisableAddBtn: false
          })
       
      })
      .catch(e => {
        this.props.dispatch(
          notifyError(this.props.translate('somthingWentWrongMessage'))
        )
      })
  }

  checkRequiredFields () {
    if (this.state.value) {
      this.setState({
        isVisableAddBtn: true
      })
    } else {
      this.setState({
        isVisableAddBtn: false
      })
    }
  }

  onChange = (name, value) => {
    this.setState({ value: value }, () => this.checkRequiredFields())
  }
  searchList = async inputValue => {
    if (!inputValue) {
      return []
    }

    let response = await apiFetch(
      `/api/users/list?userId=${this.props.logInUser.id}&search=${inputValue}&limit=100&all=true`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
    let json = await response.json()
    let result =
      (await json?.data?.data) &&
      json?.data?.data.map(item => ({
      
        ...item,
        label: item.label || item.name,
        value: item.id
      }))
    if (result.length === 0) {
      this.setState({
        resultMessage: 'No option found'
      })
    } else {
      this.setState({
        resultMessage: ''
      })
    }

    if (json.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: 'Search for more.'
      })
    }
    return result
  }
  render () {
    let { value, defaultOptions } = this.state
    return (
      <>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4} sm={6}>
              <SingleSelect
                    array={[]}
                    async
                    selectName='users'
                    isClearable={false}
                    defaultOptions={defaultOptions}
                    loadOptions={this.searchList}
                    label={this.props.translate('users')}
                    value={
                      value && value
                        ? {
                            key: value.key || '',
                            id: value.id || '',
                            label: value.label || this.props.translate('selectUser')
                          }
                        : ""
                    }
                    handleChange={this.onChange}
                    canAssign
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Button
              variant='contained'
              disabled={!this.state.isVisableAddBtn}
              onClick={() => this.formSubmit()}
            >
              {' '}
              {this.props.translate('sharedSave')}
            </Button>
          </Grid>
        </Grid>
      </>
    )
  }
}
const enhance = compose(withStyles(styles), connect())

export default enhance(ChangesOwnerShipe)
